import React from 'react'

const Dashboard = () => {
    const cards = [
        {
            title: 'PROJECTS',
            count: '1',
            image: 'https://ripl.org.in/TMS/img/Project.jpg',
            link: '/project/manageproject',
            color: 'from-blue-500 to-blue-600'
        },
        {
            title: 'ZONES',
            count: '4',
            image: 'https://ripl.org.in/TMS/img/Zone.jpg',
            link: '/zonecircle',
            color: 'from-green-500 to-green-600'
        },
        {
            title: 'CIRCLES',
            count: '14',
            image: 'https://ripl.org.in/TMS/img/Circle.jpg',
            link: '/zonecircle',
            color: 'from-purple-500 to-purple-600'
        },
        {
            title: 'CLUSTERS',
            count: '88',
            image: 'https://ripl.org.in/TMS/img/Region.jpg',
            link: '/cluster/managecluster',
            color: 'from-yellow-500 to-yellow-600'
        },
        {
            title: 'CITIES',
            count: '577',
            image: 'https://ripl.org.in/TMS/img/City.jpg',
            link: '/city/managecity',
            color: 'from-red-500 to-red-600'
        },
        {
            title: 'SITES',
            count: '580',
            image: 'https://ripl.org.in/TMS/img/Location.jpg',
            link: '/site/managesite',
            color: 'from-indigo-500 to-indigo-600'
        },
        {
            title: 'PSU DEVICES',
            count: '711',
            image: 'https://ripl.org.in/TMS/img/RMS.jpg',
            link: '/psu/managepsu',
            color: 'from-pink-500 to-pink-600'
        },
        {
            title: 'ALL FAULTS',
            count: '351',
            image: 'https://ripl.org.in/TMS/img/fault.jpg',
            link: 'report/faultreport',
            color: 'from-orange-500 to-orange-600'
        },
        {
            title: 'AC VOLTAGE FAULT',
            count: '125',
            image: 'https://ripl.org.in/TMS/img/ac.jpg',
            link: 'report/acfailreport',
            color: 'from-red-500 to-red-600'
        },
        {
            title: 'DC VOLTAGE FAULTS',
            count: '50',
            image: 'https://ripl.org.in/TMS/img/dc.jpg',
            link: '/dcvoltageleak',
            color: 'from-blue-500 to-blue-600'
        },
        {
            title: 'EARTHING FAULT',
            count: '35',
            image: 'https://ripl.org.in/TMS/img/earth.jpg',
            link: '/earthingfault',
            color: 'from-green-500 to-green-600'
        },
        {
            title: 'TEMPERATURE FAULT',
            count: '1',
            image: 'https://ripl.org.in/TMS/img/Temp.jpg',
            link: '/temperaturefault',
            color: 'from-yellow-500 to-yellow-600'
        },
        {
            title: 'ETHERNET FAULT',
            count: '108',
            image: 'https://ripl.org.in/TMS/img/ethernet.jpg',
            link: 'ethernetfault',
            color: 'from-purple-500 to-purple-600'
        },
        {
            title: 'PSU BATTERY FAULT',
            count: '38',
            image: 'https://ripl.org.in/TMS/img/InternalBatteryFault.jpg',
            link: 'batteryfault',
            color: 'from-pink-500 to-pink-600'
        },
        {
            title: 'PSU WEAK SIGNALS',
            count: '67',
            image: 'https://ripl.org.in/TMS/img/GSMSignal.jpg',
            link: '/weaksignal',
            color: 'from-indigo-500 to-indigo-600'
        },
        {
            title: 'PSU HEARTBEAT FAIL',
            count: '127',
            image: 'https://ripl.org.in/TMS/img/RMSFault.jpg',
            link: '/heartbeatfail',
            color: 'from-red-500 to-red-600'
        }
    ];

    return (
        <div className='min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6'>
            <div className='max-w-7xl mx-auto'>
                <div className='mb-6'>
                    <h1 className='text-2xl font-bold text-gray-800'>Dashboard Overview</h1>
                    <p className='text-sm text-gray-600 mt-1'>Monitor and manage your PSU devices and system status</p>
                </div>
                
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
                    {cards.map((card, index) => (
                        <a 
                            key={index} 
                            href={card.link}
                            className='transform transition-all duration-300 hover:scale-105'
                        >
                            <div className='bg-white rounded-xl shadow-md overflow-hidden'>
                                <div className={`h-1.5 bg-gradient-to-r ${card.color}`}></div>
                                <div className='p-4'>
                                    <div className='flex items-center gap-3'>
                                        <div className='p-2 bg-gray-50 rounded-lg'>
                                            <img 
                                                width={40} 
                                                src={card.image} 
                                                alt={card.title}
                                                className='rounded-md'
                                            />
                                        </div>
                                        <div>
                                            <h3 className='text-xs font-semibold text-gray-600'>{card.title}</h3>
                                            <p className='text-xl font-bold text-gray-800 mt-0.5'>{card.count}</p>
                                        </div>
                                    </div>
                                    <div className='mt-3 flex items-center justify-between text-xs text-gray-500'>
                                        <span>View Details</span>
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Dashboard
